import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Loader from 'components/layout/Loader';

import Data from 'components/Data';

class OrderDetails extends React.Component {
  render() {
    const { match, children, data } = this.props;

    return (
      <div>
        <Data dataName="order" url={'/api/orders/' + match.params.orderId + '.json'} data={data} />

        {data.pending ? <Loader /> : React.cloneElement(children, { orderData: data.data })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.data.order,
  };
};

export default withRouter(connect(mapStateToProps)(OrderDetails));
